import { ChevronRightIcon } from '../../../assets/icons/ChevronRightIcon';
import Button from '../Button';
import { Typography } from '../Typography';

type Props = {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export default function Pagination({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}: Props) {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPages;

  return (
    <div className="mt-4 flex flex-row items-center justify-end gap-4 overflow-hidden rounded-xl px-4 py-2">
      <Typography variant="body-sm" className="text-left">
        Page {currentPage} of {totalPages}
      </Typography>
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        leftIcon={<ChevronRightIcon className="rotate-180 text-neutral-500" />}
        variant="outline"
        disabled={isFirstPage}
      >
        Previous
      </Button>
      <Button
        onClick={() => onPageChange(currentPage + 1)}
        rightIcon={<ChevronRightIcon className="text-neutral-500" />}
        variant="outline"
        disabled={isLastPage}
      >
        Next
      </Button>
    </div>
  );
}
